import RndtsApiCallbaclController from './rndts-api-callback.controller';
import Template from './rndts-api-callback.html';
export default {
	controller: RndtsApiCallbaclController,
	template: Template
};
